<template>
<div class="vhtml_ui" v-html="content" @click="imageChgange($event)">

</div>
</template>

<script>
import {
    ImagePreview
} from 'vant';
export default {
    props: {
        content: {
            type: String
        }
    },
    methods: {
        imageChgange(e) {
            if (e.target.nodeName == "IMG") {
                ImagePreview({
                    images: [e.target.currentSrc], //e.target.currentSrc  当前图片src
                    showIndex: false,
                    loop: true,
                    closeOnPopstate: true
                });
            } else {
                return;
            }
        },
    },
    components:{
        [ImagePreview.name]: ImagePreview,
    }
}
</script>



// WEBPACK FOOTER //
// src/components/vHtml.vue